import styled from "styled-components";
import React from "react";
import media from "Styles/media";

interface PageWrapperProps {
	className?: string;
	active?: boolean;
	onScroll?: any;
	id?: string;
	onWheel?: (event: React.WheelEvent<HTMLDivElement>) => void;
	propsRef?: any;
}

const Wrapper = styled.div<{ active: boolean }>`
	padding-top: ${(props) => `${props.theme.size.logo.pc + props.theme.size.offset.pc * 2}px`};
	width: 100%;
	height: 100%;
	overflow: scroll;
	position: absolute;
	top: 0;
	left: 0;
	z-index: ${(props) => props.theme.zIndex.page.default};
	transition: ${(props) => props.theme.transition.default};
	transition-property: opacity;
	opacity: ${(props) => (props.active ? 1 : 0)};
	${(props) => props.theme.layout.scroll_hide};

	@media ${media.tablet} {
		padding-top: ${(props) => `${props.theme.size.logo.tablet + props.theme.size.offset.tablet * 2}px`};
	}
`;

const PageWrapper: React.FC<PageWrapperProps> = ({ children, className, active = true, onScroll, id, onWheel, propsRef }) => {
	return (
		<Wrapper className={className} active={active} onScroll={onScroll} id={id} onWheel={onWheel} ref={propsRef}>
			{children}
		</Wrapper>
	);
};

export default PageWrapper;
